<template>
    <div class="bazis-club-inside" v-if="pageTitle != null">
        <div class="container">
            <div class="section-title">
                <router-link :to="{name: 'bazis-club', hash: '#bazis-club-category'}" class="link-back">
                    <svgIcon name="left-arrow" class="icon-arrow-left"/>
                    <span v-if="globalLang == ''">Вернуться в Bazis Club</span>
                    <span v-if="globalLang == 'kz/'">Bazis Club оралу</span>
                    <span v-if="globalLang == 'en/'">Return to the Bazis Club</span>
                </router-link>
                <h1>{{pageTitle[0].category_desc}}</h1>
                <div class="filter-section">
                    <div class="filter-city-dropdown" v-if="!isMobileChecker">
                        <div class="curent-city" :class="{'open' : openDropInit}">
                            <button :class="{active : cityActive.slug === 'all'}" @click.prevent="openDrop">
                                <span v-if="globalLang == ''">Все города</span>
                                <span v-if="globalLang == 'kz/'">Барлық қалалар</span>
                                <span v-if="globalLang == 'en/'">All cities</span>
                            </button>
                            <button :class="{active : cityActive.slug === item.slug}" v-for="(item, index) in cityArr" :key="index" @click.prevent="openDrop">{{cityActive.name}}</button>
                            <div class="drop-icon">
                                <svgIcon name="arrow_drop" class="icon-svg"/>
                            </div>
                        </div>
                        <div class="city-dropdown" :class="{'open' : openDropInit}">
                            <ul>
                                <li>
                                    <button :class="{active : cityActive.slug === 'all'}" @click.prevent="filterByCity('desctop', {name: 'all', slug: 'all'})">
                                        <span v-if="globalLang == ''">Все города</span>
                                        <span v-if="globalLang == 'kz/'">Барлық қалалар</span>
                                        <span v-if="globalLang == 'en/'">All cities</span>
                                    </button>
                                </li>
                                <li v-for="(item, index) in cityArr" :key="index">
                                    <button @click.prevent="filterByCity('desctop', item)" :class="{active : cityActive.slug === item.slug}">{{item.name}}</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="mobile-filter-city" v-if="isMobileChecker">
                        <div class="select-in">
                            <select v-model="selectedCity" @change="filterByCity('mobile', $event)" id="select-sales-filter">
                                <option value="all">
                                    <span v-if="globalLang == ''">Все города</span>
                                    <span v-if="globalLang == 'kz/'">Барлық қалалар</span>
                                    <span v-if="globalLang == 'en/'">All cities</span>
                                </option>
                                <option v-for="(item, index) in cityArr" :value="item" :key="index">
                                    <span>{{item.name}}</span>
                                </option>
                            </select>
                            <div class="drop-icon">
                                <svgIcon name="arrow_drop" class="icon-svg"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bazis-club-items" v-if="cardArr != null">
                <div class="club-item" v-for="(item, index) in cardArr" :key="index">
                    <a :href="item.link" target="_blank">
                        <div class="club-item-img">
                            <img :src="item.logo" alt="">
                        </div>
                        <div class="item-info">
                            <div class="club-item-title">
                                <h3>{{item.name}}</h3>
                            </div>
                            <div class="club-item-sale-title">
                                <p v-if="globalLang == ''">Скидка<span>{{item.sale}}</span></p>
                                <p v-if="globalLang == 'kz/'">ЖЕҢІЛДІК<span>{{item.sale}}</span></p>
                                <p v-if="globalLang == 'en/'">DISCOUNT<span>{{item.sale}}</span></p>
                            </div>
                            <div class="club-item-desc">
                                <p>{{item.desc}}</p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <formPage class="form-page-bazis-club"></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import svgIcon from '@/components/partials/SvgIcon.vue';
	import formPage from '@/components/forms/form-page.vue';	

    export default {
        name: 'bazis-club-inside--page',
        components: {
            svgIcon,
            formPage,
        },
        data () {
            return {
                cardID: this.$route.params.id,
                title: this.$route.params.title,
                globalLang: window.GlobalLang,
                pageTitle: null,
                cardArr: null,
                cardArrDefault: null,
                cityActive: {
                    name: 'all',
                    slug: 'all',
                },
                openDropInit: false,
                cityArr: [],
                selectedCity: 'all',
            }
        },
        computed: mapGetters({
            pageSetup: 'loadBazisClub',
            bazisClubItems: 'loadBazisClubItems',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getData() {
                var data = this.bazisClubItems;
                // console.log(data, 'asdasasd')
                var filteredItems = data.filter(item => {
                    return (item.category.find(elem => {
                        return elem.slug == this.cardID
                    }))
                });
                // console.log(filteredItems, 'FILTER');
                this.cardArr = filteredItems;
                this.cardArrDefault = filteredItems;
                this.buildCityFilter(filteredItems);
                // this.$store.commit('setCustomCrumb', this.cardArr[0].action_title);
            },
            getCategoryTitle() {
                var data = this.pageSetup.bazis_club_category;
                var filteredItems = data.filter(item => {
                    return item.category.slug == this.cardID
                });
                // console.log(filteredItems);
                this.pageTitle = filteredItems;
                this.$store.commit('setCustomCrumb', this.pageTitle[0].category_desc);
            },
            buildCityFilter(arr) {
                // console.log(arr);
                const citiesArr = [];
                arr.forEach((item) => {
                    item.city.forEach((cityItem) => {
                        citiesArr.push({name : cityItem.name, slug : cityItem.slug})
                    });
                });

                const getUniqueValues = (array) => {
                    const seen = new Set();
                    return array.filter(item => {
                        const key = JSON.stringify(item); // Уникальный ключ для сравнения
                        if (!seen.has(key)) {
                            seen.add(key);
                            return true;
                        }
                        return false;
                    });
                };

                const uniqueArray = getUniqueValues(citiesArr);
                this.cityArr = uniqueArray;
                // console.log(uniqueArray, 'ASDSADASD')
            },
            filterByCity(param, item) {
                const cardItemsDef = this.cardArrDefault;
                if (param == 'desctop') {
                    this.openDropInit = false;
                    // console.log(item)
                    if (item.name == 'all') {
                        this.cityActive = {
                            name: 'all',
                            slug: 'all'
                        };
                        this.cardArr = this.cardArrDefault;
                    } else {
                        this.cityActive = {
                            name: item.name,
                            slug: item.slug
                        };
                        const filteredItems = cardItemsDef.filter((card) => {
                            return card.city.some(city => city.slug === item.slug);
                        });
                        this.cardArr = filteredItems;
                    }
                } else {
                    // console.log(event.target.value)
                    // console.log(this.selectedCity)
                    if (this.selectedCity != 'all') {
                        const filteredItems = cardItemsDef.filter((card) => {
                            return card.city.some(city => city.slug === this.selectedCity.slug);
                        });
                        this.cardArr = filteredItems;
                    } else {
                        this.cardArr = this.cardArrDefault;
                    }
                }
            },
            openDrop() {
                this.openDropInit = !this.openDropInit;
            }
        },
        beforeRouteEnter (to, from, next) {
            store.dispatch('getBazisClubPageData');
            if (store.state.bazisClubItems != null) {
                next(vm => {
                    vm.getData();
                    vm.getCategoryTitle();
                    vm.$store.commit('removePageLoaderImg');
                    vm.$parent.$refs.topProgress.done()
                });
            } else {
                store.dispatch('getBazisClubItems').then((response) => {
                    // console.log(resp, 'HOME')
                    if (response) {
                        next(vm => {
                            vm.getData();
                            vm.getCategoryTitle();
                            vm.$store.commit('removePageLoaderImg');
                            vm.$parent.$refs.topProgress.done()
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'bazis-club-inside';
            // this.$store.dispatch('getBazisClubPageData');
            // this.$store.dispatch('getBazisClubItems');
        },
        created () {

        },
        mounted() {
            // if (this.bazisClubItems != null) {
            //     this.getData();
            // } else {
            //     this.$store.watch(
            //         (state) => state.bazisClubItems,
            //         (newValue) => {
            //             if (newValue) {
            //                 this.getData();
            //             }
            //         }
            //     )
            // }
            // if (this.pageSetup != null) {
            //     this.getCategoryTitle();
            // } else {
            //     this.$store.watch(
            //         (state) => state.bazisClub,
            //         (newValue) => {
            //             if (newValue) {
            //                 this.getCategoryTitle();
            //             }
            //         }
            //     )
            // }
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/bazis-club/bazis-club-card.scss';
    @import '@/styles/respond/bazis-club/bazis-club-card-respond.scss';
</style>